import { SiteLocale } from 'apps/website/types/dato';
import { applyYear } from './transformers/applyYear';
import { createShortcodePricingPage } from './ShortcodePricingPage';


export type ShortcodeContext = {
  text: string;
  locale: SiteLocale;
};

export const shortcode = (text: string, locale: SiteLocale) => {
  const context: ShortcodeContext = { text, locale };

  return {
    applyYear() {
      applyYear({ context });
      return this;
    },
    pricingPage: createShortcodePricingPage(text, locale),
  };
};
